import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../services/auth';
import './ForgotPasswordPage.css';
import BrandLogo from '../components/BrandLogo';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email) {
      setError('Bitte gib deine E-Mail-Adresse ein');
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch (err: any) {
      const message = err.response?.data?.error || 'Fehler beim Senden der E-Mail';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <div className="container login-header-inner">
          <div className="login-logo">
            <Link to="/" aria-label="ELFHALBE — zur Startseite">
              <BrandLogo height={18} withIcon />
            </Link>
          </div>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
            Zur Startseite
          </button>
        </div>
      </header>
      <div className="login-container">
        <div className="login-card">
          <h1>Passwort vergessen</h1>
          {success ? (
            <div>
              <div className="success-message">
                Falls diese E-Mail-Adresse registriert ist, wurde ein Link zum Zurücksetzen des
                Passworts gesendet. Bitte prüfe dein E-Mail-Postfach.
              </div>
              <div style={{ marginTop: '20px' }}>
                <Link to="/login" className="btn btn-primary">
                  Zurück zum Login
                </Link>
              </div>
            </div>
          ) : (
            <>
              <p style={{ marginBottom: '20px', color: '#666' }}>
                Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen deines
                Passworts.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">E-Mail-Adresse</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="deine.email@example.com"
                    required
                    disabled={loading}
                  />
                </div>
                {error && <div className="error-message">{error}</div>}
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Wird gesendet...' : 'Link senden'}
                </button>
                <div className="register-link">
                  <Link to="/login">Zurück zum Login</Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
